require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./coding-interview-prep-project-euler-problem-465-polar-polygons.json") })
        }
      }, "path---coding-interview-prep-project-euler-problem-465-polar-polygons");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---coding-interview-prep-project-euler-problem-465-polar-polygons!./.cache/json/coding-interview-prep-project-euler-problem-465-polar-polygons.json
// module id = 1754
// module chunks = 231608221292675